<template>
    <section class="faq_main_wrp">
        <div id="scroll-bar"></div>
        <div class="faq_main_container">
            <div class="public_bg_clr_wrp">
                <router-link to="/" class="home_rdrtc_cross">
                    <i aria-hidden="true" class="fa fa-times-circle-o mbl_cross"></i>
                </router-link>
                <!-- <div class="faq_header_section">
                    <img src="@/assets/images/faq-banner.webp" class="img-fluid" />
                </div> -->
                <div class="container">
                    <div class="faq_head_wrp">
                        <h1 class="page_heading">Frequently Asked Questions</h1>
                        <p class="page_subheading">Have questions or need assistance. Fill out the form below, and our
                            team will get back to you promptly.</p>
                    </div>
                    <div class="faq_section">
                        <div class="faq_section_center">
                            <div class="accordion_box" id="accordion">
                                <div class="card" v-for="(item, index) in aboutsItems"
                                    v-bind:class="{ active: item.status }" :key="index">
                                    <div class="card-header">
                                        <div class="card-link">
                                            <h3 class="accordion_title">
                                                <span>{{ item.id }}</span>.
                                                {{ item.title }}
                                            </h3>
                                        </div>
                                    </div>
                                    <div class="card-body">
                                        <ul class="accordion_content">
                                            <li v-for="(listItem, index) in item.description" :key="index">
                                                <!-- <span class="fa fa-hand-o-right" aria-hidden="true"></span> -->
                                                <span v-html="listItem"></span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="faq_section">
                        <h3 class="faq_form_heading">Submit Your Questions</h3>
                        <div class="faq_form">
                            <form @submit.prevent="validateFaqOtpGenerateSubmit">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <input type="text" class="form-control" v-validate="'required'"
                                                v-model="form.fname" v-bind:class="{ 'is-invalid': errors.has('form.fname') }"
                                                name="form.fname" data-vv-as="first name" placeholder="First Name*">
                                            <small class="invalid-feedback" v-if="errors.has('form.fname')">{{
                                                errors.first('form.fname') }}</small>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <input type="text" class="form-control" v-validate="'required'"
                                                v-model="form.lname" v-bind:class="{ 'is-invalid': errors.has('form.lname') }"
                                                name="form.lname" data-vv-as="last name" placeholder="Last Name*">
                                            <small class="invalid-feedback" v-if="errors.has('form.lname')">{{
                                                errors.first('form.lname') }}</small>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="form-group">
                                            <input type="email" v-model="form.email" name="form.email" class="form-control"
                                                v-validate="'required'"
                                                v-bind:class="{ 'is-invalid': errors.has('form.email') }" data-vv-as="email"
                                                placeholder="Email" autocomplete="off">
                                            <small class="invalid-feedback" v-if="errors.has('form.email')">{{
                                                errors.first('form.email') }}</small>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="form-group">
                                            <textarea class="form-control" placeholder="Ask your questions here*"
                                                v-model="form.description" v-validate="'required'"
                                                v-bind:class="{ 'is-invalid': errors.has('form.description') }"
                                                name="form.description" data-vv-as="description"
                                                style="padding-top: 10px;"></textarea>
                                            <small class="invalid-feedback" v-if="errors.has('form.description')">{{
                                                errors.first('form.description') }}</small>
                                        </div>
                                    </div>
                                </div>
                                <div class="btn_group">
                                    <button class="btn btn-primary" :disabled="isSubmitting">Submit</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <otp-verify-popup v-if="verifyOtpPopupState" :form="form"></otp-verify-popup>
    </section>
</template>
<script>
/* eslint-disable */
import {
    bus
} from '@/main';
const $ = window.jQuery = require('jquery');
import otpVerifyPopup from "./otpVerifyPopup.vue";
import toast from '@/services/toast';
export default {
    name: 'faq-page',
    components: {
        'otp-verify-popup': otpVerifyPopup,
    },
    props: [],
    data() {
        return {
            aboutsItems: [{
                id: 1,
                title: 'What is Lymphomap?',
                description: ['Lymphomap is an AI-powered digital health ecosystem — connecting minds, data, and technology to revolutionize cancer research and treatment.'],
            },
            {
                id: 2,
                title: 'Who is a member on Lymphomap?',
                description: [
                    'Anyone in the medical, research, or healthcare field — including doctors, researchers, students, and institutions — can become a Lymphomap member by creating an online account. The platform welcomes all professionals interested in using AI for medical research and learning.'
                ],
            },
            {
                id: 3,
                title: 'Can you use Lymphomap for immediate treatment protocols?',
                description: [
                    'Lymphomap’s models are currently intended for research and educational purposes only. They cannot yet be used to guide or determine patient treatment protocols until the platform receives FDA approval.'
                ],

            },
            {
                id: 4,
                title: 'Who owns the models and algorithms used on Lymphomap?',
                description: ['Lymphomap owns the core intellectual property (IP) behind its models and algorithms. Collaboration between members and institutions is central to the platform — the technology is built to benefit both. Partners/Members can develop and use their own models created on Lymphomap under licensing agreements that allow access to Lymphomap’s technology without transferring ownership of the underlying IP.'
                ],
            },
            {
                id: 5,
                title: 'How does Lymphomap protect my data?',
                description: ['Lymphomap takes data security extremely seriously. All member and patient-related data are protected through advanced encryption, multi-layered security protocols, and continuous monitoring to prevent unauthorized access. Two-factor authentication ensures only verified members can access the platform, minimizing fraudulent activity.',
                    'Lymphomap follows data protection protocols in line with GDPR guidelines. For more information on our data security practices, please contact us at <a href="mailto:info@lymphomap.ai">info@lymphomap.ai</a>.',],
            },
            {
                id: 6,
                title: 'Does Lymphomap offer free access?',
                description: ['Lymphomap offers flexible subscription packages designed to fit each member’s needs — from fully independent use to advanced AI model-building support. Every new member starts with the Natural Package (Basic), which is free.',
                    'Members can later upgrade to the Supervised Package (Auto) or Neural Package (Pro) for additional features and personalized AI support. Institutions and hospitals can also access a dedicated Enterprise Package, available through direct coordination with our admin team.',
                    'To explore all our plans, visit <a href="www.lymphomap.ai/packages">www.lymphomap.ai/packages</a> or contact us at <a href="mailto:info@lymphomap.ai">info@lymphomap.ai</a> for enterprise inquiries.'
                ],
            },
            {
                id: 7,
                title: 'How can I book a demo on Lymphomap?',
                description: ['To schedule a demo session, visit <a href="www.lymphomap.ai.">www.lymphomap.ai.</a>',
                    'You can book a demo on Lymphomap to explore the platform and its features. Our team will walk you through the tools, services, and workflows so you can see exactly how Lymphomap can support your research or organization.',],
            },
            {
                id: 8,
                title: 'Can I collaborate on Lymphomap?',
                description: ['Yes, collaboration is at the core of Lymphomap. You can connect with professionals, form research teams, host webinars and conferences, and co-develop research papers through our integrated database, <strong>Awerack</strong>. Members can also build models together on the platform, with support from our in-house AI team for diagnostic, prognostic and other models’ development.',],
            },
            {
                id: 9,
                title: 'What services does Lymphomap offer?',
                description: ['Lymphomap brings together a suite of powerful services — from our AI/Data Lab to the research paper hub, <strong>Awerack</strong>. It’s a connected ecosystem where technology, insight, and collaboration unite to accelerate innovation and transform patient care.'],
            },
            {
                id: 10,
                title: 'What services does Lymphomap offer?',
                description: ['Lymphomap brings together a suite of powerful services — from our AI/Data Lab to the research paper hub, <strong>Awerack</strong>. It’s a connected ecosystem where technology, insight, and collaboration unite to accelerate innovation and transform patient care.',
                    'To explore all our services, visit <a href="/our/services">www.lymphomap.ai/our/services</a>.'
                ],
            },
            ],
            form:{
                fname: '',
                lname: '',
                email: '',
                description: '',
            },
            isSubmitting: false,
            verifyOtpPopupState:false,
        }
    },
    computed: {

    },
    mounted() {
        bus.$emit('showHeaderbtn', false);
        bus.$on('verifyOtpPopupStateBus', (data) => {
            this.verifyOtpPopupState = data;
            this.clearFields();
        });
    },
    created() {
        document.addEventListener('scroll', this.updateScrollBar);
        window.addEventListener('resize', this.updateScrollBar);
    },
    destroyed() {
        document.removeEventListener('scroll', this.updateScrollBar);
        window.removeEventListener('resize', this.updateScrollBar);
    },
    methods: {
        updateScrollBar() {
            var doc = document.documentElement;
            var win = window;
            var scrollTop = (doc && doc.scrollTop) || (document.body && document.body.scrollTop);
            var scrollHeight = (doc && doc.scrollHeight) || (document.body && document.body.scrollHeight);
            var clientHeight = doc ? doc.clientHeight : document.body.clientHeight;
            var scrollPercent = scrollTop / (scrollHeight - clientHeight) * 100;
            var scrollBar = document.getElementById('scroll-bar');
            scrollBar.style.width = scrollPercent + '%';
        },
        clearFields() {
            this.form.fname = '';
            this.form.lname = '';
            this.form.email = '';
            this.form.description = '';
            this.$validator.reset();
        },      
        openVerifyOtpPopupMethod() {
          this.verifyOtpPopupState = true;
          document.body.classList.add('body_right_scroll_remove');
        },  
        validateFaqOtpGenerateSubmit() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.isSubmitting = true
                    let data = {
                        email: this.form.email,
                    }
                    this.$store.dispatch('faqRequestOtpAction', data)
                        .then((res) => {
                            this.openVerifyOtpPopupMethod();
                            toast.success(res.data.msg);
                            this.isSubmitting = false;
                        }).catch((err) => {
                            this.isSubmitting = false;
                        })
                    return;
                }
            })
        },
    },
    beforeCreate: function () {
        document.body.classList.add('left_sidebaar_disabled_for_page');
        document.body.classList.add('public_page_for_wrp_img');
    },
    beforeRouteLeave: function (to, from, next) {
        document.body.classList.remove('left_sidebaar_disabled_for_page');
        document.body.classList.remove('public_page_for_wrp_img');
        next();
    },
}
</script>

<style lang="scss" scoped>
.faq_main_wrp {
    padding: 70px 0px 10px;
    color: #FFFDD0;
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color emoji;

    @media only screen and (max-width:767px) {
        padding: 70px 0px 10px;
    }

    .faq_header_section {
        height: 320px;

        img {
            object-fit: cover;
            height: 320px;
            width: 100%;
            object-position: top center;
        }
    }

    .faq_head_wrp {
        padding: 40px 0 20px;
        @media only screen and (max-width:767px){
           padding-bottom: 0px;
        }

        .page_subheading {
            text-align: center;
            font-size: 16px;
            color: #cdcfac;
        }

        .page_heading {
            color: #fffc19;
            font-size: 46px;
            margin-bottom: 15px;
            text-align: center;
            @media only screen and (max-width:767px){
             font-size: 24px;
            }
        }
    }

    .home_rdrtc_cross {
        position: absolute;
        top: 10px;
        right: 10px;
        cursor: pointer;
        z-index: 100;
        padding: 4px 10px;
        color: #e4002b;
        font-size: 28px;
        background-color: rgba(31, 31, 31, 0.5);
        border-radius: 5px;
        line-height: 1;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        border: 1px solid rgba(174, 182, 184, 0.1);
        overflow: hidden;
        display: inline-block;

        &::before {
            content: "";
            position: absolute;
            top: 0;
            width: 100%;
            height: 100%;
            background: linear-gradient(120deg,
                    transparent,
                    rgba(255, 255, 255, 0.2),
                    transparent);
            left: -100%;
            transition: all 0.65s ease-in-out;
        }

        &:hover {
            box-shadow: 1px 1px 25px 10px rgba(255, 255, 255, 0.5) !important;
            color: #ffd400;

            &::before {
                left: 100%;
            }
        }
    }

    .public_bg_clr_wrp {
        background: rgba(0, 0, 0, .9);
        padding: 0px 0px 15px;
        position: relative;

        .faq_section {
            width: 100%;
        }
    }

    .accordion_box {
        .card {
            background: linear-gradient(-30deg, rgba(37, 44, 84, 0.8) 0%, rgba(0, 0, 0, 0.8) 50%, rgba(38, 38, 38, 0.8) 50%, rgba(44, 44, 84, 0.8) 100%);
            padding: 0px;
            margin: 20px 0;
            border-radius: 8px;
            -webkit-box-shadow: 0 5px 10px 0 rgba(244, 242, 238, 0.2);
            box-shadow: 0 5px 10px 0 rgba(244, 242, 238, 0.1);
            border: 1px solid rgba(93, 93, 93, 0.4);

            .card-header {
                background: transparent;
                padding: 0px;
                border: none;
            }

            .card-link {
                font-size: 18px;
                color: #dfd084;
                line-height: 1;
                font-family: 'MyriadProRegular', 'Lato', sans-serif;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                padding: 15px 15px 10px;
                gap: 15px;
                position: relative;

                .accordion_title {
                    margin: 0;
                    font-size: 22px;
                   @media only screen and (max-width:767px) {
                        font-size: 18px;
                    }
                }

                .fa-chevron-down {
                    position: absolute;
                    right: 15px;
                    -webkit-transform: rotate(0deg);
                    -moz-transform: rotate(0deg);
                    -ms-transform: rotate(0deg);
                    transform: rotate(0deg);
                    -webkit-transition: -webkit-transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
                    transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
                }

                &[aria-expanded="true"] {
                    .fa-chevron-down {
                        -webkit-transform: rotate(180deg);
                        -moz-transform: rotate(180deg);
                        -ms-transform: rotate(180deg);
                        transform: rotate(180deg);
                        color: #ffc107;
                    }

                    .accordion_title {
                        color: #ffc107;
                    }
                }
            }

            .card-body {
                padding: 0 15px 15px 35px;
            }

            &:last-child {
                .card-body {
                    padding-left: 45px;
                }
            }

            .accordion_content {
                padding: 0px;

                li {
                    font-size: 16px;
                    margin-bottom: 12px;
                    position: relative;
                    color: #a5a59a;
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    line-height: 1.3;

                    .fa {
                        line-height: 1.3;
                    }

                    &:last-child {
                        margin-bottom: 0px;
                    }
                }
            }
        }
    }

    .faq_form_heading {
        color: #fffc19;
        font-size: 32px;
        margin-bottom: 30px;
        text-align: center;
        margin-top: 50px;
        @media only screen and (max-width:767px){
            font-size: 24px;
            margin-bottom: 20px;
            margin-top: 30px;
        }
    }

    .faq_form {
        .form-control {
            font-size: 16px;
            border-radius: 5px;
            padding: 25px 15px;
            border: 1px solid rgba(255, 255, 255, 0.1);
            outline: none !important;
            -webkit-box-shadow: none !important;
            box-shadow: none !important;
            color: #ffd400;
            background: rgba(255, 255, 255, 0.08);

            &:focus,
            &.active {
                border: 1px solid #ffd400;
            }

            &::placeholder,
            &::-webkit-input-placeholder,
            &::-moz-placeholder {
                color: rgba(255, 255, 255, 0.3);
            }

            &:focus::-webkit-input-placeholder {
                font-size: 0;
            }

            &:focus::-moz-placeholder {
                font-size: 0;
            }
        }

        .btn-primary {
            background: rgba(255, 255, 255, 0.1);
            color: #ffd400;
            font-size: 18px;
            min-width: 110px;
            min-height: 30px;
            border-radius: 4px;
            box-shadow: none !important;
            border: none !important;

            &:hover {
                background: #87cefa;
                color: #333;
            }
        }
    }

    #scroll-bar {
        position: fixed;
        top: 0;
        left: 0;
        width: 0;
        height: 5px;
        z-index: 1000;
        background: #ffc107;
    }
}
</style>

<style lang="scss">
.faq_main_wrp .accordion_box .card .accordion_content li a {
    color: #87cefa;

    &:hover {
        color: #ffc107;
    }
}
</style>